module.exports = "<div class=\"jumbotron text-center\">\n  <h1>404 Not Found</h1>\n  <p>You may be lost. Follow the breadcrumbs back <a routerLink=\"/\">home</a>.</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// /media/webdesign/5E0ECC7B0ECC4E29/www/leasytool/src/app/not-found/not-found.component.html
// module id = ../../../../../src/app/not-found/not-found.component.html
// module chunks = 1